import React from 'react';
import { Trans } from '@lingui/react/macro';
import Banner from '@/components/Banner';

interface NoAvailableFeesAlertProps {}

const NoAvailableFeesAlert: React.FC<NoAvailableFeesAlertProps> = (props) => {
    return (
        <Banner type="danger">
            <Trans>You have no available fees configured.</Trans>
        </Banner>
    );
};

export default NoAvailableFeesAlert;
